var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTnsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3096 16.0162V26L11.3043 23.085V13.3684L9.90191 14.7287L8.49948 16.081L6.25391 16.0648L4 16.0405L9.12556 11.0364C11.9471 8.2915 14.2595 6.04049 14.2762 6.04049C14.2929 6.04049 14.3096 10.5344 14.3096 16.0162ZM25.7294 16.0648L23.4588 16.081L22.0563 14.7287L20.6539 13.3684V23.085L17.6487 26V6L28 16.0405L25.7294 16.0648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnsr);
export default __webpack_public_path__ + "static/media/TNSR.1e3a010a1dae1fbb7b921a0476e321d9.svg";
export { ForwardRef as ReactComponent };